import { CoreIcon } from '../core-icon';
import pointCircleGraySVG from '../../assets/icons/point-circle-gray.svg';
import type { IconProps } from '../core-icon';

export const PointCircleGrayIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={pointCircleGraySVG} {...props} />;
};
